// src/components/ServicesSection.tsx
import React from 'react';
import { Container, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Service } from '../../../types';
import ServiceCard from './ServiceCard';

interface ServicesSectionProps {
  services: Service[];
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ services }) => {
  // Filter services to include only those with an imagePath
  const filteredServices = services.filter(service => service.imagePath);

  // Do not render section if no services to show
  if (!filteredServices.length) return null;

  return (
    <Container sx={{ mt: 4, mb: 0 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: 600, mb: 2 }}
      >
        What We Offer
      </Typography>
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        spaceBetween={20}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          450: { slidesPerView: 1 },
          550: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: 0 }}
      >
        {filteredServices.map((service) => (
          <SwiperSlide
            key={service.id}
            style={{ display: 'flex', justifyContent: 'center' }} // **Centers each slide inside the Swiper**
          >
            <ServiceCard service={service} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

export default ServicesSection;
